import React from 'react'

import RelatedTag from './Components/RelatedTag'
import Icon from '../../Shared/Icon/Icon'

export default class RelatedTags extends React.Component {
  constructor(props) {
    super(props)

    this.state = { data: [] }

    this.onFetchSimilarTagsSuccess = this.onFetchSimilarTagsSuccess.bind(this)
  }

  componentDidMount() {
    this._isMounted = true

    this.fetchSimilarTags({ tags: this.props.searchable_tag })
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  fetchSimilarTags(tag) {
    return axios.get('/api/internal/tags/suggest', { params: tag })
      .then(this.onFetchSimilarTagsSuccess)
      .catch((error) => {})
  }

  onFetchSimilarTagsSuccess(response) {
    if (this._isMounted) {
      return this.setState({ data: response.data })
    }
  }

  render() {
    const url_without_tags = this.props.current_url_without_tag
    const top_links = this.props.top_links
    const search_page = this.props.search_page

    const relatedTags = this.state.data.map((tag) => {
      return (
        <RelatedTag
          key={tag.tag}
          model_count={tag.count}
          tag={tag.tag}
          base_url={url_without_tags}
          top_links={top_links}
          search_page={search_page}
        />
      )
    })

    if (this.state.data.length > 0) {
      return (
        <ul className="list list--inline related-tags u-inline">
          <span className="u-mr10">
            <Icon type={['far', 'angle-right']} notSpaced />
          </span>
          {relatedTags}
        </ul>
      )
    }
    return null
  }
}
